module.exports = __webpack_public_path__ + "static/media/check.b149d45a.svg";